// CoinsPage.jsx - با خرید واقعی و ذخیره‌سازی per-user
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; // 🆕 اضافه شد
import "./CoinsPage.css";
import { useCoins } from "../../context/CoinContext";
import { useAuth } from "../../context/AuthContext";
import { pay } from '../../services/paymentService';

// ----------------------------------------------------------------

// ----------------------------------------------------------------
// لیست محصولات (قابل اتصال به API واقعی در آینده)
// ----------------------------------------------------------------
const PRODUCTS = [
  { id: "starter", icon: "⚡", sticker: "🔥", name: "شروع سریع", coins: 50, bonus: 0, price: 29000 },
  { id: "rainbow", icon: "🌈", sticker: "⭐", stickerClass: "pink", name: "رنگین‌کمان", coins: 150, bonus: 30, price: 79000 },
  { id: "dragon", icon: "🐉", sticker: "👑 نسخه محدود", stickerClass: "purple", name: "گنج اژدها", coins: 400, bonus: 100, price: 199000, giant: true },
  { id: "galaxy", icon: "💎", sticker: "💎", stickerClass: "green", name: "کهکشان", coins: 1000, bonus: 250, price: 499000 },
  { id: "unicorn", icon: "🦄", name: "تک‌شاخ", coins: 75, bonus: 0, price: 39000 },
];

const fmt = (n) => Number(n || 0).toLocaleString("fa-IR");

const CoinStore = () => {
  const particlesRef = useRef(null);
  const { coins } = useCoins();
  const { user } = useAuth();
  const navigate = useNavigate(); // 🆕

  const [selected, setSelected] = useState(null); // محصول انتخاب‌شده برای خرید
  const [buying, setBuying] = useState(false);
  const [toast, setToast] = useState(null);

  // ---------- ذرات پس‌زمینه ----------
  useEffect(() => {
    const container = particlesRef.current;
    if (!container) return;

    const createParticle = () => {
      const particle = document.createElement("div");
      particle.className = "particle";
      const size = Math.random() * 6 + 3;
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;
      particle.style.left = `${Math.random() * 100}%`;
      particle.style.top = `${Math.random() * 100}%`;
      particle.style.animationDuration = `${Math.random() * 10 + 8}s`;
      particle.style.animationDelay = `${Math.random() * 5}s`;
      particle.style.background = `rgba(251, 191, 36, ${Math.random() * 0.2 + 0.05})`;
      container.appendChild(particle);

      setTimeout(() => particle.parentNode && particle.remove(), 18000);
    };

    for (let i = 0; i < 20; i++) setTimeout(createParticle, i * 300);
    const interval = setInterval(createParticle, 2000);

    return () => {
      clearInterval(interval);
      if (container) container.innerHTML = "";
    };
  }, []);

  // ---------- Toast ----------
  const showToast = (type, text) => {
    setToast({ type, text });
    setTimeout(() => setToast(null), 3500);
  };

  // ---------- انتخاب محصول ----------
  const handleSelect = (p) => {
    if (!user?.id) {
      showToast("error", "🔐 برای خرید ابتدا وارد حساب خود شوید");
      return;
    }
    setSelected(p);
  };

  // ---------- تأیید خرید ----------
  const handleConfirm = async () => {
    if (!selected || buying) return;

    if (!user?.id) {
      showToast("error", "🔐 برای خرید ابتدا وارد حساب خود شوید");
      return;
    }

    setBuying(true);
    try {
      // ارسال packageId به سرور. سرور خودش قیمت را از PRICES می‌خواند
      // و کاربر را به درگاه زرین‌پال هدایت می‌کند.
      await pay.coins({
        userId: user.id,
        packageId: selected.id,
      });
      // اینجا معمولاً اجرا نمی‌شود چون کاربر ریدایرکت شده
    } catch (e) {
      console.warn("[CoinsPage] pay.coins error:", e);
      showToast("error", e.message || "❌ خطا در اتصال به درگاه پرداخت");
      setBuying(false);
    }
  };

  return (
    <div className="coins-page magic-container">
      {/* ====== پس‌زمینه ====== */}
      <div className="space-bg">
        <div className="stars-layer"></div>
        <div className="stars-layer stars-medium"></div>
        <div className="stars-layer stars-small"></div>
        <div className="nebula"></div>
        <div className="shooting-stars"></div>
      </div>

      <div className="bubbles-container" ref={particlesRef}></div>

      <div className="wave-bg">
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      {/* ====== محتوا ====== */}
      <div className="content-wrapper">
        {/* Header */}
        <div className="header-magic">
          <div className="user-magic">
            <span className="greeting">
              <span className="wave">👋</span> سلام قهرمان
            </span>
            <span className="name">
              به دنیای سکه ها خوش اومدی <span>✦</span>
            </span>
          </div>

          <div className="avatar-magic">
            <img src="/images/coin-page.png" alt="avatar" />
            {/*<span className="crown">👑</span>*/}
          </div>
        </div>

        {/* موجودی */}
        <div className="coin-display-magic">
          <div className="flying-coins">
            <span className="f-coin">🪙</span>
            <span className="f-coin">🪙</span>
            <span className="f-coin">🪙</span>
            <span className="f-coin">🪙</span>
          </div>
          <div className="coin-label-magic">
            <span className="label">🪙 موجودی کیف</span>
            <span className="amount">
              {fmt(coins)} <small>سکه</small>
            </span>
          </div>
          <span className="coin-icon-magic">🪙</span>
        </div>

        {/* چالش روزانه 
        <div className="challenge-magic">
          <div className="challenge-left-magic">
            <div className="challenge-icon-magic">
              🎯<span className="dot"></span>
            </div>
            <div className="challenge-text-magic">
              <div className="title">
                چالش <span>امروز</span>
              </div>
              <div className="desc">۳ تا از ۴ تا انجام شد 🚀</div>
            </div>
          </div>
          <div className="challenge-reward-magic">
            <span>+۲۰</span>
            <small>رایگان</small>
          </div>
        </div>*/}

        {/* عنوان بخش */}
        <div className="section-title-magic">
          <h2>
            <span className="sparkle">✨</span> پیشنهادات ویژه
            <span className="badge-magic">جدید</span>
          </h2>
          <span className="see-all-magic"></span>
        </div>

        {/* ====== کارت‌ها (کلیک‌پذیر) ====== */}
        <div className="cards-grid-magic">
          {PRODUCTS.map((p) => (
            <div
              key={p.id}
              className={`card-magic ${p.giant ? "giant" : ""}`}
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
              onClick={() => handleSelect(p)}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && handleSelect(p)
              }
              aria-label={`خرید ${p.name}`}
            >
              {p.sticker && (
                <span className={`sticker ${p.stickerClass || ""}`}>
                  {p.sticker}
                </span>
              )}
              <span className="icon">{p.icon}</span>
              <div className="name">{p.name}</div>
              <div className="coins">
                <strong>{fmt(p.coins)}</strong>
                {p.bonus > 0 ? ` + ${fmt(p.bonus)}` : " سکه"}
              </div>
              <div className="price">
                {fmt(Math.round(p.price / 1000))}
                <small>هزار</small>
              </div>
            </div>
          ))}
        </div>

        {/* دکمه‌ها */}
        <div className="actions-magic">
          <button
            className="btn-magic"
            onClick={() => navigate('/home')}
          >
            🏠 خانه
          </button>
          <button
            className="btn-magic-primary"
            onClick={() => navigate('/charge')}
          >
            ✨ شارژ فوری
          </button>
        </div>

        {/* Footer */}
        <div className="footer-magic">
          <span className="stars">✦ ✦ ✦ ✦ ✦</span>
          <span className="text">
            <strong>✦</strong> هر روز با چالش‌ها سکه جمع کن <strong>✦</strong>
          </span>
        </div>
      </div>

      {/* ====== Modal خرید ====== */}
      {selected && (
        <div style={S.backdrop} onClick={() => !buying && setSelected(null)}>
          <div style={S.modal} onClick={(e) => e.stopPropagation()}>
            <div style={{ fontSize: 60, lineHeight: 1 }}>{selected.icon}</div>
            <h3 style={{ margin: "10px 0 6px", fontSize: 20 }}>
              {selected.name}
            </h3>

            <div style={S.coinBadge}>
              🪙 {fmt(selected.coins + (selected.bonus || 0))} سکه
            </div>

            {selected.bonus > 0 && (
              <div style={S.bonusText}>
                شامل {fmt(selected.bonus)} سکه هدیه 🎁
              </div>
            )}

            <div style={S.priceRow}>
              مبلغ قابل پرداخت:{" "}
              <strong style={{ marginRight: 6, color: "#fbbf24" }}>
                {fmt(selected.price)} تومان
              </strong>
            </div>

            <div style={S.btnRow}>
              <button
                onClick={() => !buying && setSelected(null)}
                disabled={buying}
                style={S.cancelBtn}
              >
                انصراف
              </button>
              <button
                onClick={handleConfirm}
                disabled={buying}
                style={{ ...S.confirmBtn, opacity: buying ? 0.7 : 1 }}
              >
                {buying ? "⏳ در حال پرداخت..." : "✅ تأیید و پرداخت"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ====== Toast ====== */}
      {toast && (
        <div
          style={{
            ...S.toast,
            background:
              toast.type === "success"
                ? "linear-gradient(135deg,#16a34a,#22c55e)"
                : "linear-gradient(135deg,#dc2626,#ef4444)",
          }}
        >
          {toast.text}
        </div>
      )}
    </div>
  );
};

// ----------------------------------------------------------------
// استایل‌های inline modal/toast (بدون دست زدن به CoinsPage.css)
// ----------------------------------------------------------------
const S = {
  backdrop: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.7)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 20,
  },
  modal: {
    background: "linear-gradient(160deg,#1e1b4b,#312e81)",
    border: "1px solid rgba(251,191,36,0.4)",
    borderRadius: 22,
    padding: "26px 22px",
    maxWidth: 380,
    width: "100%",
    textAlign: "center",
    color: "#fff",
    boxShadow: "0 25px 70px rgba(0,0,0,0.7)",
  },
  coinBadge: {
    display: "inline-block",
    marginTop: 12,
    padding: "8px 18px",
    borderRadius: 999,
    background: "rgba(251,191,36,0.15)",
    border: "1px solid rgba(251,191,36,0.5)",
    color: "#fbbf24",
    fontSize: 20,
    fontWeight: 800,
  },
  bonusText: {
    marginTop: 8,
    color: "#22c55e",
    fontSize: 13,
    fontWeight: 600,
  },
  priceRow: {
    marginTop: 18,
    padding: "12px",
    borderRadius: 12,
    background: "rgba(255,255,255,0.05)",
    fontSize: 14,
    color: "#cbd5e1",
  },
  btnRow: { display: "flex", gap: 10, marginTop: 18 },
  cancelBtn: {
    flex: 1,
    padding: "12px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "transparent",
    color: "#cbd5e1",
    cursor: "pointer",
    fontSize: 14,
    fontFamily: "inherit",
  },
  confirmBtn: {
    flex: 1,
    padding: "12px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg,#fbbf24,#f59e0b)",
    color: "#111",
    fontWeight: 800,
    cursor: "pointer",
    fontSize: 14,
    fontFamily: "inherit",
  },
  toast: {
    position: "fixed",
    bottom: 30,
    left: "50%",
    transform: "translateX(-50%)",
    padding: "14px 24px",
    borderRadius: 14,
    color: "#fff",
    fontWeight: 700,
    boxShadow: "0 15px 40px rgba(0,0,0,0.5)",
    zIndex: 10000,
    fontSize: 15,
    maxWidth: "90vw",
    textAlign: "center",
  },
};

export default CoinStore;